import { decodeJWT } from '../../../shared/utils/jwt';

export const BASE_URL = '/api/v1';

export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const PASSWORD = '/password';
export const SIGNUP = '/signup';
export const UNLOCK = '/unlock';

// TODO: Modify Stripe Connect URLs.
export const STRIPE_CONNECT_ONBOARDING = `${BASE_URL}/payments/onboarding-link`;
export const STRIPE_CONNECT_SESSION = `${BASE_URL}/payments/account-session`;
export const PAYMENT_INTENT = `${BASE_URL}/payments/payment-intent`;

export const ACCOUNT = '/account';
export const APPOINTMENTS = '/appointments';
export const CLIENT_SIGNUP = `${BASE_URL}/website-signup`;
export const CLIENTS = '/clients';
export const CONVERSATIONS = '/conversations';
// TODO: Remove CONVERSATION when no longer required.
export const CONVERSATION = `${BASE_URL}/tasks/:taskId/conversation`;
export const DECEDENTS = '/decedents';
// TODO: Change MESSAGES to '/tasks/:taskId/messages'?
export const MESSAGES = '/messages';

export const REVIEW_REQUEST_CONFIGURATION =
  '/websites/:websiteId/review-request-configuration';

export const TASK_PRIORITIES = '/task-priorities';
export const REVIEW_REQUESTS = '/review-requests';
export const REVIEW_REQUESTS_CHANNELS = `${REVIEW_REQUESTS}/channels`;
export const REVIEWS = '/reviews';
export const SUBSCRIPTION_CANCELLATION = '/subscription/cancellation';
export const TASK_STATUSES = '/task-statuses';
export const TASKS = '/tasks';

export const THEME_EDITOR_DATA = () => {
  const { website_id: websiteId } = decodeJWT();

  return `/websites/${websiteId}/theme-editor-data`;
};

export const THEME_SETTINGS = () => {
  const { website_id: websiteId } = decodeJWT();

  return `/websites/${websiteId}/theme-settings`;
};

export const WEBSITE_APPOINTMENTS = () => {
  const { website_id: websiteId } = decodeJWT();

  return `/websites/${websiteId}/appointments`;
};

export const WEBSITE_CASE_FILES = () => {
  const { website_id: websiteId } = decodeJWT();

  return `/websites/${websiteId}/case-files`;
};

export const WEBSITE_TAGS = () => {
  const { website_id: websiteId } = decodeJWT();

  return `/websites/${websiteId}/tags`;
};

export const WEBSITE_TASKS = () => {
  const { website_id: websiteId } = decodeJWT();

  return `/websites/${websiteId}/tasks`;
};

export const USERS = '/users';

// FuneralApp Web.
export const WEBSITE_BASE_URL = gon.website_url;
